/**
 * Even search filter types
 */
export enum EventFilterType {
  COMMISSION_ID = <any>'commissionId',
  FUNDING_REFERENCE_ID = <any>'fundingReferenceId',
  PAYMENT_REFERENCE_ID = <any>'paymentReferenceId',
  PAYMENT_TYPE = <any>'type',
  DATE_RANGE_PROPERTY = <any>'dateRangeProperty',
  DATE_AFTER_PROPERTY = <any>'dateAfterProperty',
  DATE_BEFORE_PROPERTY = <any>'dateBeforeProperty',
  DATE_RANGE_AGENCY = <any>'dateRangeAgency',
  DATE_AFTER_AGENCY = <any>'dateAfterAgency',
  DATE_BEFORE_AGENCY = <any>'dateBeforeAgency',
  GUEST_NAME = <any>'guestName',
  COMPLETED = <any>'eventStatusCompleted',
  MISSING_AGENCY = <any>'eventStatusMissingAgency',
  ARCHIVED = <any>'includeArchivedEvents',
  DELETED = <any>'includeDeletedEvents',
  PAYMENT_STATUS = <any>'paymentStatus',
  EVENT_PAYMENT_STATUS = <any>'eventPaymentStatus',
  COMM_RETENTION = <any>'includeCommRetentionEvents',
  MISSING_EMAIL_CONTACT = <any>'missingContactEmail',
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-filter-type-enum.ts